module.exports = __webpack_public_path__ + "img/wz-8-3-2.213be816.jpg";